export default __webpack_public_path__ + "static/media/11.27f24c85.jpg";